import React, { useEffect, useState, useCallback } from "react";
import { Row, Col, Input, Label, Collapse, Button } from "reactstrap";
import { useSelector } from "react-redux";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LicenseTypes } from "../../constants/LicenseTypes";
import { SortingState, IntegratedSorting } from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  TableColumnResizing,
} from "@devexpress/dx-react-grid-bootstrap4";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";

const TableComponent = ({ ...restProps }) => (
  <Table.Table {...restProps} className="table-striped" />
);

export default function ShopStudentsSelect({
  studentsOnCurrentProgram,
  lastAddedProduct,
  addOrRemoveStudentFromCartItem,
  allStudentsWithLicenses,
  allStudents,
  preselectedStudent,
  removeManyFromCart,
  addManyToCart,
  allChecked,
  setAllChecked,
}) {
  const [studentsForAdding, setStudentsForAdding] = useState([]);
  const [filteredStudentsForSelect, setFilteredStudentsForSelect] = useState(
    []
  );
  const [filterStudentsBy, setFilteredStudentsBy] = useState("");
  const [studentsWithCurrentLicense, setStudentsWithCurrentLicense] = useState(
    []
  );
  const [showStudentsWithLicense, setShowStudentsWithLicense] = useState(false);

  const [columns] = useState([
    { name: "input", title: "Välj" },
    { name: "name", title: "Namn" },
    { name: "class", title: "Klass" },
    { name: "aplLicense", title: "Apl-licens" },
  ]);
  const [rowsForSelect, setRowsForSelect] = useState([]);
  const [rowsForNotSelect, setRowsForNotSelect] = useState([]);
  const [sortingForSelect, setSortingForSelect] = useState([
    { columnName: "name", direction: "asc" },
  ]);
  const [sortingForNotSelect, setSortingForNotSelect] = useState([
    { columnName: "name", direction: "asc" },
  ]);
  const [sortingStateColumnExtensions] = useState([
    { columnName: "input", sortingEnabled: false, width: 10 },
    { columnName: "name", sortingEnabled: true },
    { columnName: "class", sortingEnabled: true },
    { columnName: "aplLicense", sortingEnabled: false },
  ]);

  const defaultColumnWidths = [
    { columnName: "input", width: 100 },
    { columnName: "name", width: 300 },
    { columnName: "class", width: 300 },
    { columnName: "aplLicense", width: 400 },
  ];
  const cart = useSelector((state) => state.newCartReducer);

  const checkStudentHasLicense = useCallback(
    (studentLicenses) => {
      const lastAddedValidFrom = lastAddedProduct.isPlusPackage
        ? lastAddedProduct.plusPackage.validFrom
        : lastAddedProduct.validFrom;

      const lastAddedYears = lastAddedProduct.isPlusPackage
        ? lastAddedProduct.studentLicense.years
        : 3;

      if (studentLicenses.hasValidAplLicense) {
        if (
          moment(studentLicenses.aplLicenseValidTo) >=
          moment(lastAddedValidFrom)
        ) {
          return true;
        }
      } else if (studentLicenses.aplLicenseValidFrom) {
        let newStartDate = moment(lastAddedValidFrom).format("YYYYMMDD");
        let newEndDate = moment(lastAddedValidFrom)
          .add(lastAddedYears, "y")
          .format("YYYYMMDD");
        let existingStartDate = moment(
          studentLicenses.aplLicenseValidFrom
        ).format("YYYYMMDD");
        let existingEnddate = moment(studentLicenses.aplLicenseValidTo).format(
          "YYYYMMDD"
        );
        if (newEndDate > existingStartDate && newStartDate < existingEnddate) {
          return true;
        }
      }

      return false;
    },
    [lastAddedProduct]
  );

  useEffect(() => {
    let tempAllStudentsWithLicenseWithoutName = [];
    let studentsWithCurrentStudentLicense = [];
    let studentsWithConflictingAplLicense = [];
    if (lastAddedProduct.isPlusPackage) {
      studentsOnCurrentProgram.forEach((stud) => {
        if (checkStudentHasLicense(stud.licenses)) {
          studentsWithConflictingAplLicense.push(stud);
        }
      });
    }
    //Set studentsWithCurrentStudentLicense
    tempAllStudentsWithLicenseWithoutName =
      allStudentsWithLicenses.resultNew.filter((stud) =>
        stud.programLicenseIds.includes(
          lastAddedProduct.isPlusPackage
            ? lastAddedProduct.studentLicense.programLicenseId
            : lastAddedProduct.programLicenseId
        )
      );
    tempAllStudentsWithLicenseWithoutName.forEach((licStud) => {
      let currStud = allStudents.result.find(
        (stud) => stud.id === licStud.studentId
      );
      if (currStud) {
        let studentToAdd = {
          name: currStud.name,
          id: currStud.id,
          class: currStud.class,
          licenses: licStud.programLicenseIds,
        };
        studentsWithCurrentStudentLicense.push(studentToAdd);
      }
    });
    //If generic apl license selected show all students
    if (lastAddedProduct.type === LicenseTypes.APLOnly) {
      let tempStudentsForNotChoosing = [];
      let tempStudentsForChoosing = [];
      const tempAllStudents = [];
      allStudents.result.forEach((stud) => {
        const licenses = allStudentsWithLicenses.resultNew.find(
          (studWL) => studWL.studentId === stud.id
        );
        let studentToAdd = {
          name: stud.name,
          id: stud.id,
          class: stud.class,
          licenses: licenses,
        };
        tempAllStudents.push(studentToAdd);
      });
      tempAllStudents.forEach((stud) => {
        if (checkStudentHasLicense(stud.licenses)) {
          tempStudentsForNotChoosing.push({ ...stud, hasApl: true });
        } else {
          tempStudentsForChoosing.push({ ...stud, hasApl: false });
        }
      });
      setStudentsForAdding(tempStudentsForChoosing);
      setFilteredStudentsForSelect(tempStudentsForChoosing);
      setStudentsWithCurrentLicense(tempStudentsForNotChoosing);
      //If pluslicense Show only students on current program that doesnt have apl
    } else if (
      lastAddedProduct.type === LicenseTypes.PlusLicense ||
      lastAddedProduct.type === LicenseTypes.StudentLicencePlus
    ) {
      let tempStudentsForNotChoosing = [];
      let tempStudentsForChoosing = [];
      const tempAllStudents = [];
      allStudents.result.forEach((stud) => {
        const licenses = allStudentsWithLicenses.resultNew.find(
          (studWL) => studWL.studentId === stud.id
        );
        let studentToAdd = {
          name: stud.name,
          id: stud.id,
          class: stud.class,
          licenses: licenses,
        };
        tempAllStudents.push(studentToAdd);
      });
      tempAllStudents.forEach((stud) => {
        if (checkStudentHasLicense(stud.licenses)) {
          tempStudentsForNotChoosing.push({ ...stud, hasApl: true });
        } else {
          tempStudentsForChoosing.push({ ...stud, hasApl: false });
        }
      });
      tempStudentsForChoosing = tempStudentsForChoosing.filter((stud) =>
        stud.licenses.programLicenseIds.includes(
          lastAddedProduct.programLicenseId
        )
      );
      tempStudentsForChoosing = tempStudentsForChoosing.filter((stud) =>
        studentsOnCurrentProgram.some((progStud) => progStud.id === stud.id)
      );
      setStudentsForAdding(tempStudentsForChoosing);
      setFilteredStudentsForSelect(tempStudentsForChoosing);
      setStudentsWithCurrentLicense(tempStudentsForNotChoosing);
      //StudentLicens, visa alla elever som inte har elevlicens
    } else if (lastAddedProduct.type === LicenseTypes.StudentLicense) {
      let tempStudentsForChoosing = studentsOnCurrentProgram.filter(
        (stud) =>
          !stud.licenses.programLicenseIds.includes(
            lastAddedProduct.programLicenseId
          )
      );
      let tempStudentsForNotChoosing = studentsOnCurrentProgram.filter((stud) =>
        stud.licenses.programLicenseIds.includes(
          lastAddedProduct.programLicenseId
        )
      );
      setStudentsWithCurrentLicense(tempStudentsForNotChoosing);
      setStudentsForAdding(tempStudentsForChoosing);
      setFilteredStudentsForSelect(tempStudentsForChoosing);
    } else if (lastAddedProduct.isPlusPackage) {
      //Visa alla elever som inte har licens och som inte har apl för perioden.
      let tempStudentsForChoosing = studentsOnCurrentProgram.filter(
        (stud) =>
          !stud.licenses.programLicenseIds.includes(
            lastAddedProduct.studentLicense.programLicenseId
          )
      );
      studentsWithConflictingAplLicense.forEach((studwithconflict) => {
        tempStudentsForChoosing = tempStudentsForChoosing.filter(
          (stud) => stud.id !== studwithconflict.id
        );
      });

      let tempStudentsForNotChoosing = studentsOnCurrentProgram.filter((stud) =>
        stud.licenses.programLicenseIds.includes(
          lastAddedProduct.studentLicense.programLicenseId
        )
      );
      studentsWithConflictingAplLicense.forEach((studWithconflicting) => {
        if (
          !tempStudentsForNotChoosing.some(
            (stud) => stud.id === studWithconflicting.id
          )
        ) {
          tempStudentsForNotChoosing.push({
            ...studWithconflicting,
            hasApl: true,
          });
        } else {
          tempStudentsForNotChoosing.find(
            (stud) => stud.id === studWithconflicting.id
          ).hasApl = true;
        }
      });
      setStudentsWithCurrentLicense(tempStudentsForNotChoosing);
      setStudentsForAdding(tempStudentsForChoosing);
      setFilteredStudentsForSelect(tempStudentsForChoosing);
    }

    if (preselectedStudent) {
      setStudentsForAdding(
        studentsOnCurrentProgram.filter(
          (stud) => stud.id === preselectedStudent.id
        )
      );
      setFilteredStudentsForSelect(
        studentsOnCurrentProgram.filter(
          (stud) => stud.id === preselectedStudent.id
        )
      );
    }
  }, [
    studentsOnCurrentProgram,
    lastAddedProduct,
    allStudents.result,
    allStudentsWithLicenses.resultNew,
    allStudents.loading,
    allStudentsWithLicenses.loading,
    preselectedStudent,
    checkStudentHasLicense,
  ]);

  useEffect(() => {
    if (filterStudentsBy.length > 0) {
      setFilteredStudentsForSelect(
        studentsForAdding.filter(
          (stud) =>
            stud.name.toLowerCase().includes(filterStudentsBy.toLowerCase()) ||
            stud.class.name
              .toLowerCase()
              .includes(filterStudentsBy.toLowerCase())
        )
      );
    } else {
      setFilteredStudentsForSelect(studentsForAdding);
    }
  }, [filterStudentsBy, studentsForAdding]);

  const handleToggleAllStudents = () => {
    if (allChecked) {
      removeManyFromCart(filteredStudentsForSelect);
      setAllChecked(false);
    } else {
      addManyToCart(filteredStudentsForSelect);
      setAllChecked(true);
    }
  };

  const handleGetCheckStatus = useCallback(
    (studentId) => {
      if (lastAddedProduct.isPlusPackage) {
        if (
          cart.result.some(
            (cartitem) =>
              cartitem.fortnoxNumber ===
                lastAddedProduct.studentLicense.fortnoxNumber &&
              cartitem.addedStudents.some(
                (addedstud) => addedstud.id === studentId
              )
          )
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        if (
          cart.result.some(
            (cartitem) =>
              cartitem.fortnoxNumber === lastAddedProduct.fortnoxNumber &&
              cartitem.addedStudents.some(
                (addedstud) => addedstud.id === studentId
              )
          )
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    [lastAddedProduct, cart.result]
  );

  useEffect(() => {
    if (lastAddedProduct) {
      let tempStudentsForSelect = [];
      filteredStudentsForSelect.forEach((stud, i) => {
        let tempStudentToAdd = {
          input: null,
          name: null,
          class: null,
          aplLicense: null,
        };
        tempStudentToAdd.name = stud.name;
        tempStudentToAdd.input = (
          <Input
            style={{
              marginLeft: "1em",
              marginRight: "1em",
              marginTop: "0",
              position: "relative",
              cursor:
                lastAddedProduct.type !== LicenseTypes.StudentLicense &&
                checkStudentHasLicense(stud.licenses)
                  ? "not-allowed"
                  : "cursor",
            }}
            type="checkbox"
            onChange={() => addOrRemoveStudentFromCartItem(stud)}
            checked={handleGetCheckStatus(stud.id)}
            disabled={
              lastAddedProduct.type !== LicenseTypes.StudentLicense &&
              checkStudentHasLicense(stud.licenses)
            }
          />
        );
        tempStudentToAdd.class = stud.class.name;
        tempStudentToAdd.aplLicense =
          lastAddedProduct.type === LicenseTypes.StudentLicense ? (
            ""
          ) : stud.licenses.aplLicenseValidTo !== null ? (
            stud.licenses.hasValidAplLicense ? (
              <>
                <FormattedMessage id="StudentHasAValidAplLicenseUntil" />{" "}
                {moment(stud.licenses.aplLicenseValidTo).format("YYYY-MM-DD")}
              </>
            ) : (
              <FormattedMessage
                values={{
                  dateFrom: moment(stud.licenses.aplLicenseValidFrom).format(
                    "YYYY-MM-DD"
                  ),
                  dateUntil: moment(stud.licenses.aplLicenseValidTo).format(
                    "YYYY-MM-DD"
                  ),
                }}
                id="StudentHasAValidAplLicenseFromUntil"
              />
            )
          ) : null;
        tempStudentsForSelect.push(tempStudentToAdd);
      });
      setRowsForSelect(tempStudentsForSelect);
    }
  }, [
    filteredStudentsForSelect,
    addOrRemoveStudentFromCartItem,
    checkStudentHasLicense,
    lastAddedProduct,
    cart.result,
    handleGetCheckStatus,
  ]);

  useEffect(() => {
    let tempStudentsForNotSelect = [];
    studentsWithCurrentLicense.forEach((stud, i) => {
      let tempStudentToAdd = {
        input: null,
        name: null,
        class: null,
        aplLicense: null,
      };
      tempStudentToAdd.name = stud.name;
      tempStudentToAdd.input = (
        <Input
          style={{
            marginLeft: "1em",
            marginRight: "1em",
            marginTop: "0",
            position: "relative",
            cursor: "not-allowed",
          }}
          type="checkbox"
          checked={true}
          disabled={true}
        />
      );
      tempStudentToAdd.class = stud.class.name;
      tempStudentToAdd.aplLicense =
        lastAddedProduct.type === LicenseTypes.StudentLicense ? (
          ""
        ) : stud.licenses.aplLicenseValidTo !== null ? (
          stud.licenses.hasValidAplLicense ? (
            <>
              <FormattedMessage id="StudentHasAValidAplLicenseUntil" />{" "}
              {moment(stud.licenses.aplLicenseValidTo).format("YYYY-MM-DD")}
            </>
          ) : (
            <FormattedMessage
              values={{
                dateFrom: moment(stud.licenses.aplLicenseValidFrom).format(
                  "YYYY-MM-DD"
                ),
                dateUntil: moment(stud.licenses.aplLicenseValidTo).format(
                  "YYYY-MM-DD"
                ),
              }}
              id="StudentHasAValidAplLicenseFromUntil"
            />
          )
        ) : null;
      tempStudentsForNotSelect.push(tempStudentToAdd);
    });
    setRowsForNotSelect(tempStudentsForNotSelect);
  }, [studentsWithCurrentLicense, lastAddedProduct.type]);

  return (
    <>
      <Row className="mb-2">
        <Col lg="4" md="4" sm="6" xs="12">
          <Input
            type="text"
            placeholder="Filtrera elever på namn eller klass..."
            onChange={(data) => setFilteredStudentsBy(data.target.value)}
          ></Input>
        </Col>
      </Row>
      <Row>
        <Col>
          <Label for="checkAll">
            <FormattedMessage id="SelectSlashUnselectAll" />
          </Label>
          <Input
            style={{ marginLeft: ".5em" }}
            name="checkAll"
            type="checkbox"
            onChange={() => handleToggleAllStudents()}
            checked={allChecked}
          />
        </Col>
      </Row>

      <Grid rows={rowsForSelect} columns={columns}>
        <SortingState
          sorting={sortingForSelect}
          onSortingChange={setSortingForSelect}
          columnExtensions={sortingStateColumnExtensions}
        />

        <IntegratedSorting />
        <Table
          noDataRowComponent={() => (
            <>
              <div style={{ height: "0", paddingBottom: "125%" }}></div>
              <div
                style={{
                  position: "absolute",
                  top: "14em",
                  textAlign: "center",
                  width: "98%",
                }}
              >
                <big className="text-muted">
                  <FormattedMessage id="NoStudentsToChoose" />
                </big>
              </div>
            </>
          )}
          tableComponent={TableComponent}
        />
        <TableColumnResizing defaultColumnWidths={defaultColumnWidths} />

        <TableHeaderRow showSortingControls />
      </Grid>

      <>
        <Row className="mt-4">
          <Col>
            <Button
              color="primary"
              outline
              onClick={() =>
                setShowStudentsWithLicense(!showStudentsWithLicense)
              }
              className="mb-3"
            >
              {showStudentsWithLicense ? (
                <FontAwesomeIcon className="me-2" icon="chevron-down" />
              ) : (
                <FontAwesomeIcon className="me-2" icon="chevron-right" />
              )}
              <FormattedMessage id="ShowStudentsWithLicense" />
            </Button>
          </Col>
        </Row>
        <Collapse isOpen={showStudentsWithLicense}>
          <Grid rows={rowsForNotSelect} columns={columns}>
            <SortingState
              sorting={sortingForNotSelect}
              onSortingChange={setSortingForNotSelect}
              columnExtensions={sortingStateColumnExtensions}
            />

            <IntegratedSorting />
            <Table
              tableComponent={TableComponent}
              noDataRowComponent={() => (
                <>
                  <div style={{ height: "0", paddingBottom: "125%" }}></div>
                  <div
                    style={{
                      position: "absolute",
                      top: "14em",
                      textAlign: "center",
                      width: "98%",
                    }}
                  >
                    <big className="text-muted">
                      <FormattedMessage id="NoStudents" />
                    </big>
                  </div>
                </>
              )}
            />
            <TableColumnResizing defaultColumnWidths={defaultColumnWidths} />

            <TableHeaderRow showSortingControls />
          </Grid>
        </Collapse>
      </>
    </>
  );
}
